import React from 'react'
import { LineItemInterface, StyledLineItem, StyledFlex } from './LineItem'
import { defined, definedNotNull } from 'shared/presenters/presenter'
import { Text } from 'library/atoms/Typography'
import Flex from 'shared/library/atoms/Flex'
import Price from 'shared/library/atoms/Price'
import { StoreItemPresenter } from 'shared/presenters/StoreItemPresenter'
import Thumbnail from 'shared/library/atoms/Thumbnail'

const LineItemPurchasedStoreItem = ({ item, outlet }: LineItemInterface) => {
  const storeItem = new StoreItemPresenter(
    item?.purchased_store_item?.store_item || {}
  )

  return (
    <StyledLineItem key={item.id}>
      <Flex alignItems="center">
        <Thumbnail thumbnailSize={40} src={storeItem.imageURL()} />
        <StyledFlex>
          <Text>
            {storeItem.name()} x{' '}
            {definedNotNull(item.purchased_store_item?.quantity)}
          </Text>
          <Price
            pence={defined(item.price_paid)}
            currency={outlet.currency()}
          />
        </StyledFlex>
      </Flex>
    </StyledLineItem>
  )
}

export default LineItemPurchasedStoreItem
